import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, color = "text-sovereign" }) => (
  <p className={`font-mono text-[11px] sm:text-xs font-bold tracking-[0.3em] uppercase ${color}`}>
    {children}
  </p>
);

export const SectionHeading = ({ eyebrow, title, center = false }) => (
  <div className={center ? "text-center" : ""}>
    {eyebrow && <Reveal><Eyebrow>{eyebrow}</Eyebrow></Reveal>}
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-100">
        {title}
      </h2>
    </Reveal>
  </div>
);
